import { useMealPlanStore } from "@/lib/meal-plan-store";
import { Loader2, CalendarDays, X } from "lucide-react";
import { useTranslation } from "react-i18next";

export function MealPlanProgressBar() {
  const { t } = useTranslation();
  const { state, cancelAndClearQueue } = useMealPlanStore();

  if (!state.generating || state.scope !== "week") return null;

  const { completedDays, totalDays, queueDepth } = state;
  const pct = totalDays > 0 ? Math.round((completedDays / totalDays) * 100) : 0;

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] pointer-events-none">
      <div className="h-1 bg-background/80">
        <div
          className="h-full bg-gradient-to-r from-primary via-emerald-400 to-primary transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="flex items-center gap-2 px-4 py-1.5 bg-background/95 border-b border-border/40 backdrop-blur-sm pointer-events-auto">
        <Loader2 className="w-3 h-3 text-primary animate-spin shrink-0" />
        <CalendarDays className="w-3 h-3 text-primary shrink-0" />
        <span className="text-[11px] font-medium text-foreground">
          {t("mealPlanProgressBar.generating")}
        </span>
        <span className="text-[11px] text-muted-foreground">
          — {t("mealPlanProgressBar.day", { completed: completedDays, total: totalDays })}
        </span>
        <div className="ml-auto flex items-center gap-2">
          {queueDepth > 0 && (
            <span className="text-[10px] text-amber-400 font-medium">
              {t("mealPlanProgressBar.queued", { count: queueDepth })}
            </span>
          )}
          {queueDepth === 0 && completedDays > 0 && (
            <div className="flex gap-0.5">
              {Array.from({ length: totalDays }).map((_, i) => (
                <div
                  key={i}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    i < completedDays
                      ? "bg-primary"
                      : "bg-muted-foreground/30"
                  }`}
                />
              ))}
            </div>
          )}
          <button
            onClick={cancelAndClearQueue}
            className="flex items-center justify-center w-4 h-4 rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/60 transition-colors shrink-0"
            aria-label="Cancel week plan generation"
            title="Cancel and clear queue"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      </div>
    </div>
  );
}
